import Splide from "@splidejs/splide";

window.addEventListener('DOMContentLoaded', () => {

    let blocks = document.getElementsByClassName('cff-wrapper');

    if(blocks){

        Array.from(blocks).forEach( block => {

            // get items from DOM
            let items = block.querySelectorAll('.cff-item');

            // container for slides
            let splideList = document.createElement('div');
            splideList.className = 'splide__list';

            // Add all the slides to container
            items.forEach( item => {
                let splideSlide         = document.createElement('div');
                splideSlide.className   = 'splide__slide ' + item.className;
                splideSlide.innerHTML   = item.innerHTML;
                splideList.appendChild(splideSlide);
            });
            
            // Splide track
            let splideTrack = document.createElement('div');
            splideTrack.className = 'splide__track';
            splideTrack.appendChild(splideList);

            // add content to slider
            let slider = document.createElement('div');
            slider.className = 'splide review-slider';
            slider.appendChild(splideTrack)
            
            // add slider to page

            let postsContainer  = block.querySelector('.cff-posts-wrap');
            postsContainer.style.display = "none";
            let parentEl        = postsContainer.parentNode;
            parentEl.insertBefore( slider, postsContainer );
            
        });


        let sliders = document.querySelectorAll('.splide.review-slider');

        if(sliders){
            
            Array.from(sliders).forEach( slider => {
                
                console.log(slider);
                
                new Splide( slider, {
                    type   : 'loop',
                    perPage: 3,
                    perMove: 1,
                    pagination: false,
                    arrows: true,
                    gap: '36px',
                    autoplay: true,
                    speed: 1000,
                    interval: 4000,
                    breakpoints: {
                        960: {
                            perPage: 2,
                        },
                        660: {
                            perPage: 1,
                        }
                    }
                } ).mount();
            })
        }
        
    }

});